module.exports = __webpack_public_path__ + "static/media/enem.0f217481.png";